import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

import {
  mldStakingDeposit,
  getCalculateReward,
  mldWithdraw,
} from "./contractData";
import { approve, init } from "../../config/provider";
import { mldStakingAddress } from "../../config/data";
import { ms } from "../../config/common";
import { ethers } from "ethers";
import { Modal, ModalClose, Sheet } from "@mui/joy";
import {
  Heading,
  ButtonWrapper,
  InputWrapper,
  Input,
  SelectWrapper,
  SelectHeading,
  // Select,
  LordRatioWrapper,
  Option,
  LordpriceWrapper,
  Lordprice,
  RequiredText,
  TotalMldTentureAmountContainer,
  MaxbuttonWrapper,
  DepositeContainer,
  MaxButton,
  CalculatorButtonWrapper,
  CalculatorButton,
  CalculatorCardWrapper,
  LineWrapper,
  Line,
  PreMaturityTextWrapper,
  PreMaturityText,
  PreMaturityTextBig,
  PreMaturityContainer,
  TableWrapper,
  Table,
  TableRow,
  TableRowCellWrapper,
  TableHead,
  TableCell,
  MatureDatatext,
  PrematureButtonWrapper,
  PrematureButton,
} from "./Farmstyled";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { makeStyles } from "@mui/styles";
const SuccessIcon = `${environmentVariables?.cdnUrl}successicon.png`
const InfoIcon    = `${environmentVariables?.cdnUrl}infogrey.png`
import {
  gasEstimateMLDStake,
  gasEstimateMLDWithdraw,
} from "../../config/gasEstimation";
import environmentVariables from "../../config/environmentVariables";
import axios from "axios";
import TransactionLoader from "../../Components/TransactionLoader/TransactionLoader";
import { userBalanceContext } from "../../context/userBalanceContext";
import CircularLoader from "../../Components/CircularLoader/CircularLoader";
import { buyTokenPopUpContext } from "../../context/buyTokenPopUpContext";
import ComingSoon from "../../Components/ComingSoon/ComingSoon";
const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
    "@media (max-width: 400px)": {
      maxWidth: "220px",
      minWidth: "320px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));

const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-items: center;
  margin-bottom: ${(p) => p.theme.spacing.sm};
  margin-top: ${(p) => p.theme.spacing.lg};
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    flex-direction: column;
    margin-top: 0;
  }
`;

const TextNoData = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #e1e1e1;
  margin: 0 auto;
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
`;

const Select = styled.select`
  padding: 10px 15px;
  width: 100% !important;
  height: 50px;
  margin: 0px;
  outline: none;
  border: none;
  font-size: 18px;
  border-radius: 25px;
  cursor: pointer;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAdVBMVEUAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhMdQaAAAAJ3RSTlMAAAECAwQGBwsOFBwkJTg5RUZ4eYCHkJefpaytrsXGy8zW3+Do8vNn0bsyAAAAYElEQVR42tXROwJDQAAA0Ymw1p9kiT+L5P5HVEi3qJn2lcPjtIuzUIJ/rhIGy762N3XaThqMN1ZPALsZPEzG1x8LrFL77DHBnEMxBewz0fJ6LyFHTPL7xhwzWYrJ9z22AqmQBV757MHfAAAAAElFTkSuQmCC);
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;
  @media (max-width: 768px) {
    background-position: calc(100% - 1px) center;
  }
`;

const NftNameConfirmHead = styled.div`
  font-size: 24px;
  font-weight: 600;
`;

const BuyPop = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 16px;
  font-weight: 600;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: capitalize;
  background-color: #171e22;
  padding: 25px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 35px;
  width: 170px;
  margin-top: 20px;
  cursor: pointer;
  &:hover {
  }
`;

const NftNameConfirm = styled.div`
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: space-between;
`;

const Button = styled.button`
  /* background-color: #1b798d; */

  background-color: ${(props) => (props.disabled ? "#283f44" : "#1b798d")};
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  height: 50px;
  line-height: 20px;
  text-align: center;
  padding: 15px 20px;
  border: 1px solid #1b798d;
  color: #ffffff;
  outline: none;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  display: flex;
  border: none;
  justify-content: center;
  cursor: ${(p) => (p.disabled ? "" : "pointer")};
  width: 100%;
  margin-top: 10px;

  & :hover {
    background: #1c3741;
    color: #208da5;
  }
`;
const CardWrapperMain = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (max-width: 1024px) {
    /* flex-direction: column; */
  }
`;
const CardWrapper = styled.div`
  width: calc(50% - 20px);
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    width: 100%;
    margin-bottom: ${(p) => p.theme.spacing.sm};
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const Card = styled.div`
  width: 100%;
  background-color: #151a1c;
  background-size: 100% 100%;
  background-position: right;
  padding: ${(p) => p.theme.spacing.sm};
  border-radius: ${(p) => p.theme.radius.xs};
  display: flex;
  align-items: center;

  ${(p) =>
    p.CardInitial &&
    `
  color:1px solid #88fefe;
  outline:none;
  border:none;
 `}
  ${(p) =>
    p.card2 &&
    `
 display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: start;
 `}
  ${(p) =>
    p.finalapi &&
    `
      padding:0;
 `}

 ${(p) =>
    p.STACKINGCALCULATOR &&
    `

 background-image:none;
 background:none;

 `}
`;
const WithDrawlButton = styled(Button)`
  border: 1px solid #88fefe;
  color: #88fefe;
  width: 100%;
`;

const TableCard = styled(Card)`
  margin-bottom: 30px;
  margin-top: 80px;
  @media (max-width: 768px) {
    margin: 0;
  }
  @media (max-width: 1024px) {
    margin: 0;
  }
`;

const APYTableContainer = styled.div`
  width: 100%;
  margin: 0;
`;
const InfoSectionClick = styled.div`
  position: absolute;
  background-color: #fff;
  border-radius: 10px 10px 10px 0;
  padding: 10px 15px;
  bottom: 25px;
  left: 30px;
  color: #767676;
  font-size: 14px;
  font-family: lato;
  letter-spacing: 0.1px;
  max-width: 300px;
  width: 300px;
`;

const APYTable = styled.div`
  width: 100%;
  border-collapse: collapse;
  /* border: 1px solid #cccccc3b; */
  display: flex;
  flex-direction: column;
`;

const TableHeadingApy = styled.div`
  display: flex;
  width: 100%;
`;
const APYTableHeader = styled.div`
  padding: 10px;
  width: 50%;
  text-align: center;
  /* background-color: #f2f2f2; */
  background-color: transparent;
  /* border: 1px solid #cccccc3b; */
`;

const APYTableData = styled.div`
  padding: 10px;
  /* border: 1px solid #cccccc3b; */
  text-align: center;
  width: 50%;
`;
const SheetMaterialuiStyle = styled(Sheet)`
  @media (max-width: 768px) {
    width: 330px !important;
    padding: 20px 0 0 !important;
  }
  @media (max-width: 1024px) {
    width: 330px !important;
    padding: 20px 0 0 !important;
  }
`;

const ConfirmButtonWrapperPopup = styled.div`
  display: flex;
  flex-direction: column;
`;

const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;

const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmSubHead3 = styled.div`
  font-size: 16px;
  color: #fff;
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const InfoIco = styled.img`
  width: 28px;
  height: 28px;
  margin-left: 10px;
  cursor: pointer;
`;

const InfoIcoMain = styled.div`
  position: relative;
`;

const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  // @media(max-width: 600px) {
  //   top: -25px;
  //   right: -14px;
  // }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const ConfirmButtonPopup = styled.button`
  background: linear-gradient(45deg, #1a6d7e, #04a1c1);
  border-radius: 30px;
  outline: none;
  border: none;
  font-size: 18px;
  padding: 20px 80px;
  margin: 25px 0;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  -webkit-transition: 1s;
  transition: 1s;
  margin: 15px 2px;
`;
const DialogStyledUpdate = styled(Dialog)``;
const SuccessMain = styled.div`
  position: relative;
  color: #fff;
  border: 1px solid #484848;
  padding: 50px;
  width: 600px;
  border-radius: 10px;
  background-color: #2a2a2a;
  display: flex;
  align-items: center;
  flex-direction: column;
  /* top:10%;
  left: 38%; */
  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }
`;

const RootPopup = styled.div`
  position: fixed;
  /* top:100px; */
  /* background-color: #186e80; */
  /* border-radius: 10px; */
  /* width:80%; */
  /* width: 375px; */
  height: fit-content;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1000;
  /* padding: 30px; */
  display: flex;
  flex-direction: column;
  /* ${(p) =>
    p.fullwidth &&
    `
      width:22%;
    `} */
  /* @media(max-width:${(p) => p.theme.screen.md}) {
    width: 40%;
    left: 30%;
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 50%;
    left: 25%;
  }
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    width: 60%;
    left: 20%;
  }
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    width: 75%;
    left: 12.5%;
  }
  @media (max-width: ${(p) => p.theme.screen.xxxs}) {
    width: 85%;
    left: 7.5%;
  } */
`;
const OverLay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  background-color: rgb(0 0 0 / 60%);
  left: 0px;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const NftNameConfirmHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  max-height: 35px;
  justify-content: space-between;
`;
const SuccessIconI = styled.img`
  width: 70px;
  padding-bottom: 20px;
`;
const CopyIcon = styled.div`
  position: relative;
  color: white;
  cursor: pointer;
  padding: 0 0 0 15px;
  @media (max-width: 425px) {
    padding: 0 0 0 5px;
  }
`;

const ToolTipSpan = styled.span`
  width: 80px;
  background-color: #f3eded;
  color: #080808;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 145%;
  margin-left: -60px;
  opacity: 1;
  font-weight: 700;
  transition: opacity 0.3s;
  ::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #f3eded transparent transparent transparent;
  }
`;

const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
`;
const NftNameConfirm3 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  /* padding-bottom: 20px; */
  padding-top: 20px;
  justify-content: space-between;
`;
const DetailsHead = styled.div`
  font-size: 16px;
  display: flex;
  color: #fff;
  text-transform: capitalize;
`;

const NftNameConfirm4 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 50px;
`;
const AmountHead = styled.div`
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  padding-top: 5px;
  text-transform: capitalize;
`;
const AmountSubHead = styled.div`
  font-size: 16px;
  color: #6c6c6c;
  text-transform: capitalize;
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
`;
const Image = styled.img`
  width: 12%;
`;

const InfoSection = ({
  getAllTheInformation,
  defaultAccount,
  userLatestIndex,
  minMld,
  lordRatio,
  allowance,
  setAllContractDetails,
  monthToSecData,
  clearData,
  setCallFun,
  allContractDetails,
  finalApyData,
  setShowPopup,
  infoOpen,
  setInfoOpen,
  apyinfoOpen,
  setApyinfoOpen,
  totalMLDStaked,
  setTotalMLDStaked,
}) => {
  const user_Matic_Bal =
    allContractDetails?.maticBal?._hex / 1000000000000000000;

  const classes = useStyles();
  const [depositValue, setDepositValue] = useState(
    parseInt(ethers.formatEther(minMld.toString())) || 0
  );
  const [showDepositPopup, setShowDepositPopup] = useState(false);
  const [showWithdrawPopup, setShowWithdrawPopup] = useState(false);
  const { setIsBuyOpen, setPopUpCurrency } = useContext(buyTokenPopUpContext);
  const [loading, setLoading] = useState(false);
  // const [finalDepositValue, setFinalDepositValue] = useState(0);
  const { userBalance } = useContext(userBalanceContext);
  const [lordPrice, setLordPrice] = useState(0);
  const [comingSoonPopup,setComingSoonPopUp] = React.useState(false);
  const [finalLordPrice, setFinalLordPrice] = useState(0);
  const [calculateRew, setCalculateRew] = useState(null);
  const [matureData, setMatureData] = useState([]);
  const [gasFee, setGasFee] = useState(0);
  const [selectSec, setSelectSec] = useState(7776000);
  const [selectAmount, setSelectAmount] = useState(7776000);
  const [noOfMld, setNoOfMld] = useState(null);
  const [maturityAmount, setMaturityAmount] = useState(0);
  const [lordDeposit, setLordDeposit] = useState(0);
  const [open, setOpen] = useState(false);
  const [withdrawl, setWithdrawl] = useState(false);
  const [confirmopen, setConfirmopen] = useState(false);
  const [lowBalancePopUp, setLowBalancePopup] = useState(false);

  const [successPopup, setSuccessPopup] = useState(false);
  const [depositeConfirmPopup, setDepositeConfirmPopup] = useState(false);
  const [prematureConfirmPopup, setPreMatureConfirmPopup] = useState(false);
  const [matureDataLoading, setMatureDataLoading] = useState(false);
  const [preMaturePopup, setPreMaturePopup] = useState(false);
  const [isStakeError, setIsStakeError] = useState(false);
  const [isInsufficient, setIsInsufficient] = useState(false);
  const [message, setMessage] = useState("");
  const [transactionHashStake, setTransactionHashStake] = useState(
    "transactionhashafterstake"
  );
  const [transactionFeeStake, setTransactionFeeStake] = useState(0);
  const [depositeTransHash, setDepositeTransHash] = useState(null);
  const [preMatureConfirm, setPreMatureConfirm] = useState(false);
  const [preTransactionHash, setPreTransactionHash] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const handleLogin = () => {
    try {
      init()
        .then((res) => {
          setAllContractDetails(res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };
  const CopyAddress = async (transHash) => {
    try {
      if (transHash) {
        navigator.clipboard.writeText(transHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error copying text:", error);
    }
  };
  useEffect(() => {
    if (lordRatio) {
      const value = (Number(lordRatio) * depositValue) / 100;
      const roundedValue = Number(value.toFixed(4));
      setLordPrice(roundedValue);

      const b = parseInt(ethers.parseEther(roundedValue.toString()));
      setFinalLordPrice(b);

      // setCalculate();
    }
  }, [depositValue]);

  useEffect(() => {
    if (minMld && allContractDetails) {
      setDepositValue(parseInt(ethers.formatEther(minMld.toString())));

      // setFinalDepositValue(minMld);
    } else {
      setDepositValue(0);
    }
  }, [minMld, allContractDetails]);

  // const setCalculate = async () => {
  //   const b = parseInt(
  //     ethers.parseEther(depositValue.toString())
  //   );
  // setCalculateRew(
  //   await getCalculateReward(
  //     allContractDetails?.mldStakingContract,
  //     b.toString(),
  //     selectSec
  //   )
  // );
  // };
  const triggerPusher = (address) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/trigger_event`,
      headers: {},
      data: {address:address.toLowerCase()}
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const callStake = async (mldStakeAmount, selectSec) => {
    await mldStakingDeposit(
      allContractDetails?.mldStakingContract,
      mldStakeAmount.toString(),
      selectSec
    )
      .then((res) => {
        if (res !== null) {
          console.log(res, "responseafterstaking");
          setTransactionHashStake(res?.hash);
          setTransactionFeeStake(
            parseFloat(
              (Number(res?.gasLimit || res?.effectiveGasPrice?._hex ||res?.gasUsed) *
                Number(res?.gasPrice || res?.gasUsed?._hex)) /
                1000000000000000000
            ).toFixed(4)
          );
          // console.log(res, "asdasdasdassdasd 0000");
          setLoading(false);
          setShowDepositPopup(true);
          if (userLatestIndex !== null) {
            fetchingData(parseInt(userLatestIndex));
          }
          setDepositeTransHash(res?.transactionHash||res?.hash);
          triggerPusher(allContractDetails?.address);
          axios
            .get(
              `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
            )
            .then((res) => {console.log(res)})
            .catch((err) => console.log(err));
        }
      })
      .catch((err) => {
        setLoading(false);
        setMessage(err?.response?.data?.message || err?.message);
        setIsStakeError(true);
        console.log("err", err);
      });
  };

  async function stakeIfAllowed() {
    try {
      setTransactionFeeStake(0);
      setTransactionHashStake("");
      const b = parseInt(ethers.parseEther(depositValue.toString()));
      // Check balance of user for both tokens
      const balanceMld = userBalance.MLDBalance;
      const balanceLord = userBalance.LORDBalance;
      const mldStakeAmount = b;
      const caluclatedLordAmount = finalLordPrice;

      // Check if user has enough balance for both tokens
      if (balanceMld >= mldStakeAmount && balanceLord >= caluclatedLordAmount) {
        // Check allowance for both tokens
        const mldAllowance = allowance.MLDAllowance;
        const lordAllowance = allowance.LORDAllowance;

        // Check if user has enough allowance for both tokens
        if (
          mldAllowance >= mldStakeAmount &&
          lordAllowance >= caluclatedLordAmount
        ) {
          // Call stake function
          await callStake(mldStakeAmount.toString(), selectSec);
        } else {
          // Check which allowance is low and call approve function
          if (mldAllowance < mldStakeAmount) {
            await approve(
              allContractDetails?.mldTokenContract,
              mldStakingAddress,
              allContractDetails?.provider
            );
          }
          if (lordAllowance < caluclatedLordAmount) {
            await approve(
              allContractDetails?.lordTokenContract,
              mldStakingAddress,
              allContractDetails?.provider
            );
          }

          await callStake(mldStakeAmount.toString(), selectSec);
        }
      } else {
        // Check which token balance is low
        if (balanceMld < mldStakeAmount) {
          // console.log("MLD Token balance is low.");
          // alert("MLD Token balance is low.");
          setLowBalancePopup(true);

          setLoading(false);
        } else if (balanceLord < caluclatedLordAmount) {
          console.log("Lord Token balance is low.");
          // alert("Lord Token balance is low.");
          setPopUpCurrency("LORD");
          setLowBalancePopup(true);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      setMessage(error?.response?.data?.message || error?.message);
      setIsStakeError(true);
    }
  }

  const closeDepositeConfirmPopup = () => {
    setDepositeConfirmPopup(false);
  };

  const currentDate = new Date();
  const monthAbbreviation = currentDate.toLocaleString("default", {
    month: "short",
  });
  const handleChangeStakingCalMLD = (e) => {
    let stakingVal = e.target.value;
    if (stakingVal < 0) {
      e.preventDefault();
    } else if (stakingVal >= 0 && stakingVal <= 100000) {
      setNoOfMld(stakingVal);
    } else {
      e.preventDefault();
    }
  };
  const day = currentDate.getDate();
  const year = currentDate.getFullYear();
  let hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  if (hours > 12) {
    hours -= 12;
  }

  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedDateTime = `${monthAbbreviation} ${day} ${year}, ${hours}:${formattedMinutes} ${ampm}`;

  const fetchingData = async (maxIndex) => {
    try {
      // const arr = [];
      // let mldStaked = 0;
      // for (let index = 0; index <= maxIndex; index++) {
      //   const deposits = await getUserDeposits(
      //     allContractDetails?.mldStakingContract,
      //     defaultAccount,
      //     parseInt(index)
      //   );
      //   arr.push({
      //     durationStaked: parseInt(deposits.durationStaked),
      //     lordStaked: ethers.formatEther(deposits.lordStaked), //need
      //     maturity: parseInt(deposits.maturity) * 1000,
      //     maturityAmount: ethers.formatEther(deposits.maturityAmount), //need
      //     mldStaked: parseInt(ethers.formatEther(deposits.mldStaked)), //need
      //     start: parseInt(deposits.start) * 1000,
      //     index: parseInt(index),
      //   });
      //   mldStaked += parseFloat(ethers.formatEther(deposits.mldStaked));
      //   // console.log(mldStaked, "mldstakedcnsol");
      // }
      setMatureDataLoading(true);
      axios
        .get(
          `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/get_mld_staking_data?address=${allContractDetails?.address}`
        )
        .then((res) => {
          if (res?.data?.data?.userData) {
            setTotalMLDStaked(res?.data?.data?.userData?.mldStaked);
            setMatureData(res?.data?.data?.userData?.mldStakingData);
          }
          setMatureDataLoading(false);
        });
    } catch (err) {
      console.log(err);
      setMatureDataLoading(false);
    }
  };

  // useEffect(() => {
  //   if (userLatestIndex !== null) {
  //     fetchingData(parseInt(userLatestIndex));
  //   }
  // }, [userLatestIndex]);
  useEffect(() => {
    if (allContractDetails) {
      fetchingData();
    } else {
      setMatureData([]);
      setTotalMLDStaked(0);
    }
  }, [allContractDetails]);
  const withdraw = async (id) => {
    try {
      setTransactionFeeStake(0);
      setTransactionHashStake("");
      await mldWithdraw(allContractDetails?.mldStakingContract, id)
        .then(async (data) => {
          if (data !== null) {
            setTransactionHashStake(data?.transactionHash||data?.hash);
            setTransactionFeeStake(
              (
                (Number(data?.effectiveGasPrice?._hex||data?.gasUsed) *
                  Number(data?.gasUsed?._hex||data?.gasPrice)) /
                1000000000000000000
              ).toFixed(4)
            );
            console.log(data, "withdrawmldfromstake");
            // console.log(data, "asdasdasdassdasd 111");
            setLoading(false);
            setShowWithdrawPopup(true);
            setCallFun(true);
            setPreTransactionHash(data.transactionHash);
            setTimeout(() => {
              setCallFun(false);
            }, 5000);
            if (userLatestIndex !== null) {
              fetchingData(parseInt(userLatestIndex));
            }
            triggerPusher(allContractDetails?.address);
            axios
              .get(
                `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
              )
              .then((res) =>{ console.log(res)})
              .catch((err) => console.log(err));
            // await clearData();
            // await getAllTheInformation();
          }
        })
        .catch((err) => {
          console.log("err after staking", err);
          setLoading(false);
          setMessage("Something went wrong, please try again later");
          setIsStakeError(true);
          return;
        });
    } catch (err) {
      console.log(err);
    }
  };
  console.log(depositeConfirmPopup, "depositconfirmpopup");

  const withdrawPopup = async () => {
    setShowWithdrawPopup(false);
    await clearData();
    await getAllTheInformation();
  };

  const depositPopup = async () => {
    setShowDepositPopup(false);
    await clearData();
    await getAllTheInformation();
  };
  // console.log("...........///////////totalstacked",matureData.length)

  // console.log(
  //   "maturityAmount",
  //   parseFloat(maturityAmount / 1000000000000000000).toFixed(2)
  // );
  // console.log(
  //   "lordDeposit",
  //   parseFloat(lordDeposit / 1000000000000000000).toFixed(2)
  // );

  const originalValue = parseFloat(matureData.mldStaked);
  const formattedValue = originalValue.toFixed(2); // Format to two decimal places
  const fivePercentValue = (originalValue * 0.05).toFixed(2); // Calculate 5% and format it

  const explorerHandler = () => {
    let explorerUrl = "";

    explorerUrl = `https://polygonscan.com/tx/${transactionHashStake}`;

    if (transactionHashStake) {
      window.open(explorerUrl, "_blank");
    } else {
      console.error("Invalid token name or transaction hash");
    }
  };
  const handleDeposit = async () => {
    setComingSoonPopUp(true);
    return;
    const b = parseInt(ethers.parseEther(depositValue.toString()));
    // Check balance of user for both tokens
    const balanceMld = userBalance.MLDBalance;
    const balanceLord = userBalance.LORDBalance;
    const mldStakeAmount = b;
    const caluclatedLordAmount = finalLordPrice;
    // await callStake(mldStakeAmount.toString(), selectSec);

    const gas = await gasEstimateMLDStake(
      allContractDetails?.mldStakingContract,
      mldStakeAmount.toString(),
      selectSec,
      allContractDetails?.address
    );

    console.log(gas,'kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk')

    if (userBalance?.MATIC < 0.07) {
      setMessage(`Insufficient Matic`);
      setPopUpCurrency("MATIC");
      setIsInsufficient(true);
      return;
    } else if (gas > user_Matic_Bal) {
      setMessage(`Insufficient Matic`);
      setPopUpCurrency("MATIC");
      setIsInsufficient(true);
      return;
    } else {
      setGasFee(gas);
      setDepositeConfirmPopup(true);
    }
  };
  const handlePremature = async (index) => {
    try {
      setGasFee(0);
      if (userBalance?.MATIC < 0.03) {
        setMessage(`Insufficient Matic`);
        setIsInsufficient(true);
        return;
      }
      const gas = await gasEstimateMLDWithdraw(
        index,
        allContractDetails?.address
      );
      // console.log(gas, "gas fee unstake ------------->");
      setGasFee(gas);
      if (userBalance?.MATIC < gas) {
        setMessage(`Insufficient Matic`);
        setPopUpCurrency("MATIC");
        setIsInsufficient(true);
        return;
      }
      setPreMaturePopup(true);
    } catch (err) {
      console.log(err);
    }
  };
  const handleKeyPress = (event) => {
    const keyCode = event.keyCode ||  event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isCtrlPressed = event.ctrlKey || event.metaKey; // Check if Ctrl key is pressed

    if (
      keyCode === 8 || // Allow backspace key (key code 8)
      keyCode === 46 ||
      (keyCode >= 48 && keyCode <= 57) ||  // Allow numeric keys (0-9)
      (isCtrlPressed && keyValue === "r") || // Allow Ctrl+R combination
      keyCode === 37 || // Allow left arrow key (key code 37)
      keyCode === 39 // Allow right arrow key (key code 39)
    ) {
      // Check for plus (+) and minus (-) symbols
      if (keyValue === "+" || keyValue === "-") {
        event.preventDefault();
      }
    } else {
      event.preventDefault();
    }
  };
  return (
    <>
      {loading && <TransactionLoader />}
      {comingSoonPopup && <ComingSoon stakeConfirmPopup={comingSoonPopup} setStakeConfirmPopup={setComingSoonPopUp} isMLD={true}/>}
      <Root>
        <DialogStyledUpdate
          open={isStakeError}
          onClose={() => setIsStakeError(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { overflow: "initial", backgroundColor: "transparent" },
          }}
        >
          <ButtonCancel onClick={() => setIsStakeError(false)} color="primary">
            X
          </ButtonCancel>
          <div className={classes.customButton}>
            {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

            <NftNameConfirm>
              <NftNameConfirmHead>{message}</NftNameConfirmHead>
            </NftNameConfirm>

            {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
            {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
          </div>
        </DialogStyledUpdate>
        <DialogStyledUpdate
          open={isInsufficient}
          onClose={() => setIsInsufficient(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { overflow: "initial", backgroundColor: "transparent" },
          }}
        >
          <ButtonCancel
            onClick={() => setIsInsufficient(false)}
            color="primary"
          >
            X
          </ButtonCancel>
          <div className={classes.customButton}>
            {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

            <NftNameConfirm>
              <NftNameConfirmHead>{message}</NftNameConfirmHead>
              <BuyPop
                onClick={() => {
                  setIsBuyOpen(true);
                  setIsInsufficient(false);
                  setTimeout(() => {
                    setIsBuyOpen(false);
                  }, 1000);
                }}
              >
                Click here to Buy
              </BuyPop>
            </NftNameConfirm>

            {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
            {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
          </div>
        </DialogStyledUpdate>
        <DialogStyledUpdate
          open={lowBalancePopUp}
          onClose={() => setLowBalancePopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { overflow: "initial", backgroundColor: "transparent" },
          }}
        >
          <ButtonCancel
            onClick={() => setLowBalancePopup(false)}
            color="primary"
          >
            X
          </ButtonCancel>
          <div className={classes.customButton}>
            {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

            <NftNameConfirm>
              <NftNameConfirmHead>Insufficient Balance</NftNameConfirmHead>
              <BuyPop
                onClick={() => {
                  setIsBuyOpen(true);
                  setLowBalancePopup(false);
                  setTimeout(() => {
                    setIsBuyOpen(false);
                  }, 1000);
                }}
              >
                Click here to Buy
              </BuyPop>
            </NftNameConfirm>
          </div>
        </DialogStyledUpdate>

        <CardWrapperMain>
          <CardWrapper style={{ marginBottom: "30px" }}>
            <Heading>
              STAKE
              <InfoIcoMain>
                <InfoIco
                  onClick={(e) => {
                    e.stopPropagation();
                    setInfoOpen(!infoOpen);
                    setApyinfoOpen(false);
                  }}
                  src={InfoIcon}
                />
                {infoOpen && (
                  <InfoSectionClick>
                    Lock $MLD for the ROI of 120%
                  </InfoSectionClick>
                )}
              </InfoIcoMain>
            </Heading>

            <Card style={{ display: "flex", flexDirection: "column" }}>
              <TotalMldTentureAmountContainer>
                <LordRatioWrapper>
                  <InputWrapper>
                    <SelectHeading>Amount</SelectHeading>
                    <Input
                      type="number"
                      value={depositValue}
                      placeholder="$MLD"
                      // min={
                      //   parseInt(ethers.formatEther(minMld.toString())) || 1
                      // }
                      max={userBalance.MLDBalanceDec}
                      style={{ width: "40px" }}
                      onChange={(e) => {
                        // setDepositValue(e.target.value);
                        if (
                          Number(e.target.value) >= 0 &&
                          Number(e.target.value) <= userBalance.MLDBalanceDec
                        ) {
                          // console.log(depositValue, "depositValuedepositValue");
                          // const b = parseInt(
                          //   ethers.parseEther(e.target.value.toString())
                          // );
                          // setFinalDepositValue(b);
                          setDepositValue(e.target.value);
                        } else {
                          // const b = parseInt(
                          //   ethers.parseEther(
                          //     parseInt(
                          //       ethers.formatEther(minMld.toString())
                          //     ).toString()
                          //   )
                          // );
                          // console.log('b', b)
                          // setFinalDepositValue(b);
                          // setDepositValue(
                          //   parseInt(
                          //     ethers.formatEther(minMld.toString())
                          //   ) || 0
                          // );
                          setDepositValue(0);
                        }
                      }}
                      onKeyDown={handleKeyPress}
                    />
                  </InputWrapper>
                  <LordpriceWrapper>
                    <Lordprice>{lordPrice} lord Required to Stake</Lordprice>
                    {/* <LordTextWrapper>
                      <LordText> BUY Lord</LordText>
                    </LordTextWrapper> */}
                  </LordpriceWrapper>
                </LordRatioWrapper>

                <SelectWrapper>
                  <SelectHeading>Tenure</SelectHeading>
                  <Select
                    value={selectSec}
                    onChange={(e) => {
                      setSelectSec(e.target.value);
                    }}
                  >
                    <Option>Select</Option>
                    {monthToSecData.map((data) => {
                      return (
                        <>
                          <Option value={data.sec}>{data.month} Months</Option>
                        </>
                      );
                    })}
                  </Select>
                  {/* <Lordprice>.</Lordprice> */}
                </SelectWrapper>
              </TotalMldTentureAmountContainer>

              <DepositeContainer>
                <MaxbuttonWrapper>
                  <MaxButton
                    onClick={() => {
                      const str = userBalance.MLDBalanceDec.toString();
                      const b = parseInt(ethers.parseEther(str));
                      // setFinalDepositValue(b);
                      setDepositValue(userBalance.MLDBalanceDec);
                    }}
                  >
                    Max
                  </MaxButton>
                </MaxbuttonWrapper>
                <ButtonWrapper
                  style={{
                    width: "50%",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  DepositWrapper
                >
                  <Button
                    style={{
                      width: "100%",
                      padding: "12px 20px",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                    bdcolor="skyColor"
                    disabled={
                      finalLordPrice === 0 ||
                      depositValue === 0 ||
                      selectSec === 0 ||
                      depositValue <
                        parseInt(ethers.formatEther(minMld.toString()))
                    }
                    color="skyColor"
                    radius="xl"
                    top="xs"
                    bottom="xs"
                    left="sm"
                    right="sm"
                    // onClick={(e) => {
                    //   e.preventDefault();
                    //   setLoading(true);
                    //   stakeIfAllowed();
                    // }}
                    onClick={handleDeposit}
                  >
                    Deposit
                  </Button>
                </ButtonWrapper>
              </DepositeContainer>
            </Card>
            <RequiredText>
              {" "}
              NOTE :- Minimum{" "}
              {parseInt(ethers.formatEther(minMld.toString())) || 100} MLD
              Required to Stake
            </RequiredText>
          </CardWrapper>

          <Dialog
            open={depositeConfirmPopup}
            onClose={(e) => {
              setDepositeConfirmPopup(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: { overflow: "initial", backgroundColor: "transparent" },
            }}
          >
            <ButtonCancel onClick={closeDepositeConfirmPopup} color="primary">
              X
            </ButtonCancel>
            <div className={classes.customButton}>
              <DialogTitle
                id="alert-dialog-title"
                style={{
                  textAlign: "left",
                  fontSize: "28px",
                  fontWeight: "500",
                  padding: "0",
                }}
              >
                Lock your stake
              </DialogTitle>
              <DialogContent style={{ padding: "0 0 40px" }}>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{
                    textAlign: "left",
                    color: "#bbb",
                    fontSize: "16px",
                  }}
                >
                  Double-check your details to complete the transaction
                </DialogContentText>
              </DialogContent>

              <NftNameConfirm>
                <NftNameConfirmHead>$MLD Stake :</NftNameConfirmHead>
                <NftNameConfirmHead>
                  {parseFloat(depositValue).toFixed(2)}
                </NftNameConfirmHead>
              </NftNameConfirm>

              <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Lord Burn :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead3>
                  {(depositValue * 0.1).toFixed(2)} Lord
                </NftAmountConfirmSubHead3>
              </NftAmountConfirmHeadPur>
              <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Tenure :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead3>
                  {selectSec / 2592000} Months
                </NftAmountConfirmSubHead3>
              </NftAmountConfirmHeadPur>
              <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead3>
                  {
                    gasFee
                      ? `${gasFee?.toFixed(4) || "0.0015"} POL`
                      : `0.07524 POL`
                    // <span style={{ color: "red" }}>Cannot estimate gas!</span>
                  }
                </NftAmountConfirmSubHead3>
              </NftAmountConfirmHeadPur>

              <DialogActions>
                <PayButtons>
                  <ButtonConfirm
                    onClick={(e) => {
                      setDepositeConfirmPopup(false);

                      e.preventDefault();
                      setLoading(true);
                      stakeIfAllowed();
                    }}
                    color="primary"
                    autoFocus
                  >
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions>
            </div>
          </Dialog>

          {/* <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={depositeConfirmPopup}
        onClose={() => setDepositeConfirmPopup(false)}
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 500,
            borderRadius: 'md',
            p: 3,
            boxShadow: 'lg',
          }}
        >
          <ModalClose variant="plain" sx={{ m: -1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            fontWeight="lg"
            mb={1}
          >
           Are you want to sure to stake a nfts
          </Typography>
          <Typography id="modal-desc" textColor="text.tertiary">
            Make sure to use you are staking a nft 
          </Typography>
          <button 
            onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      stakeIfAllowed();
                      setDepositeConfirmPopup(false);
                    }}
          >confirm</button>
        </Sheet>
      </Modal> */}

          <CardWrapper>
            <Heading>
              Final ROI
              <InfoIcoMain>
                <InfoIco
                  onClick={(e) => {
                    e.stopPropagation();
                    setApyinfoOpen(!apyinfoOpen);
                    setInfoOpen(false);
                  }}
                  src={InfoIcon}
                />
                {apyinfoOpen && (
                  <InfoSectionClick>
                    Rate of interest earned on your staked assets ($MLDs) in
                    reference to a certain period of time.
                  </InfoSectionClick>
                )}
              </InfoIcoMain>
            </Heading>
            <Card finalapi>
              <APYTableContainer>
                <APYTable>
                  <TableHeadingApy>
                    <APYTableHeader>Months</APYTableHeader>
                    <APYTableHeader> APY </APYTableHeader>
                  </TableHeadingApy>

                  {finalApyData
                    ?.sort((a, b) => a.month - b.month)
                    .map((apy) => {
                      return (
                        <TableHeadingApy>
                          <APYTableData>{`${apy?.month} Month`}</APYTableData>
                          <APYTableData>{`${apy?.number} %`}</APYTableData>
                        </TableHeadingApy>
                      );
                    })}
                </APYTable>
              </APYTableContainer>
            </Card>

            <CalculatorButtonWrapper onClick={() => setOpen(true)}>
              <CalculatorButton> Staking Calculator</CalculatorButton>
            </CalculatorButtonWrapper>

            <Modal
              aria-labelledby="modal-title"
              aria-describedby="modal-desc"
              open={open}
              onClose={() => {
                setOpen(false);
                setNoOfMld("");
                setMaturityAmount(0);
                setLordDeposit(0);
              }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SheetMaterialuiStyle
                variant="outlined"
                sx={{
                  width: 600,
                  borderRadius: "10px",
                  border: "1px solid #919191a3",
                  p: 3,
                  boxShadow: "lg",
                }}
                style={{ backgroundColor: "#172930" }}
              >
                <ModalClose
                  variant="outlined"
                  sx={{
                    top: "calc(-1/4 * var(--IconButton-size))",
                    right: "calc(-1/4 * var(--IconButton-size))",
                    boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                    borderRadius: "50%",
                    bgcolor: "background.body",
                  }}
                />
                <CalculatorCardWrapper>
                  <Heading STACKINGCALCULATOR> STAKING CALCULATOR </Heading>
                  <Card
                    STACKINGCALCULATOR
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <TotalMldTentureAmountContainer
                      style={{ flexDirection: "column " }}
                    >
                      <div style={{ display: "flex", width: "100%" }}>
                        <LordRatioWrapper>
                          <InputWrapper>
                            <SelectHeading PopUpText>Amount</SelectHeading>
                            <Input
                              PopUpText
                              type="number"
                              placeholder="0"
                              max={10000}
                              value={noOfMld}
                              onChange={handleChangeStakingCalMLD}
                            />
                          </InputWrapper>
                          <LordpriceWrapper></LordpriceWrapper>
                        </LordRatioWrapper>

                        <SelectWrapper>
                          <SelectHeading PopUpText>Tenure</SelectHeading>
                          <Select
                            value={selectAmount}
                            onChange={(e) => {
                              setSelectAmount(e.target.value);
                            }}
                          >
                            <Option>select one</Option>
                            {monthToSecData.map((data) => {
                              return (
                                <>
                                  <Option value={data.sec}>
                                    {data.month} Months
                                  </Option>
                                </>
                              );
                            })}
                          </Select>
                        </SelectWrapper>
                      </div>

                      <Button
                        style={{
                          color: "#fff",
                          fontSize: "22px",
                          fontWeight: "500",
                          backgroundImage:
                            "linear-gradient(45deg, #1a6d7e, #04a1c1)",
                        }}
                        disabled={noOfMld == null || noOfMld < 100}
                        onClick={async () => {
                          const mldNo = ethers.parseEther(
                            parseFloat(noOfMld).toFixed(4).toString()
                          );
                          // setNoOfMld(" ");
                          // console.log("mldNo", mldNo);
                          let calculateReward = 0;
                          if (allContractDetails?.address) {
                            calculateReward = await getCalculateReward(
                              allContractDetails?.mldStakingContract,
                              mldNo,
                              selectAmount
                            );
                          } else {
                            console.log("reward calculator");
                            if (selectAmount == 7776000) {
                              calculateReward =
                                (parseFloat(noOfMld) +
                                  parseFloat(noOfMld) * 0.1952876712) *
                                1000000000000000000;
                            } else if (selectAmount == 15552000) {
                              calculateReward =
                                (parseFloat(noOfMld) +
                                  parseFloat(noOfMld) * 0.390575342) *
                                1000000000000000000;
                            } else if (selectAmount == 31104000) {
                              calculateReward =
                                (parseFloat(noOfMld) +
                                  parseFloat(noOfMld) * 1.18356164) *
                                1000000000000000000;
                            }
                          }
                          setMaturityAmount(
                            parseFloat(
                              BigInt(calculateReward) / 1000000000000000000n
                            )
                              .toFixed(2)
                              .replace(/[.,]00$/, "")
                          );

                          const value = (Number(lordRatio) * noOfMld) / 100;
                          setLordDeposit(value);
                          // setNoOfMld("");
                        }}
                      >
                        Calculate
                      </Button>
                    </TotalMldTentureAmountContainer>

                    <DepositeContainer>
                      <LineWrapper>
                        <Line />
                      </LineWrapper>
                    </DepositeContainer>
                    <PreMaturityContainer>
                      <PreMaturityTextWrapper>
                        <PreMaturityText>Maturity Amount:</PreMaturityText>
                        <PreMaturityTextBig>
                          {parseFloat(maturityAmount)
                            .toFixed(6)
                            .replace(/[.,]00$/, "") || "0"}
                        </PreMaturityTextBig>
                      </PreMaturityTextWrapper>
                      <PreMaturityTextWrapper>
                        <PreMaturityText>Lord to be deposited:</PreMaturityText>
                        <PreMaturityTextBig>
                          {" "}
                          {parseFloat(lordDeposit).toFixed(6) || 0}
                        </PreMaturityTextBig>
                      </PreMaturityTextWrapper>
                    </PreMaturityContainer>
                  </Card>
                </CalculatorCardWrapper>
              </SheetMaterialuiStyle>
            </Modal>
          </CardWrapper>
        </CardWrapperMain>
      </Root>

      {allContractDetails?.address ? (
        <>
          {matureDataLoading ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                }}
              >
                <CircularLoader></CircularLoader>
              </div>
            </>
          ) : (
            <>
              {" "}
              <TableCard>
                <TableWrapper>
                  <MatureDatatext>Mature Data</MatureDatatext>
                  <Table>
                    <TableRow>
                      <TableHead>mld Staked</TableHead>
                      <TableHead>lord Staked</TableHead>
                      <TableHead>duration Staked</TableHead>
                      <TableHead>Maturity Amount</TableHead>
                      {/* <TableHead>start</TableHead>
              <TableHead>maturity</TableHead> */}
                      <TableHead
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "10px 0",
                        }}
                      >
                        action
                      </TableHead>
                    </TableRow>
                    {matureData?.length > 0 &&
                      matureData
                        .sort((a, b) => a.maturity - b.maturity)
                        .map((mData) => {
                          // console.log("mData", mData);
                          return (
                            <>
                              <TableRowCellWrapper>
                                <TableCell>
                                  {`${parseFloat(mData.mldStaked).toFixed(
                                    2
                                  )} $MLD`}
                                </TableCell>
                                <TableCell>
                                  {`${parseFloat(mData.lordStaked).toFixed(
                                    2
                                  )} $LORD`}
                                </TableCell>

                                <TableCell>
                                  {ms(mData.durationStaked * 1000)} Month
                                </TableCell>
                                <TableCell>
                                  {`${parseFloat(mData.maturityAmount)
                                    .toFixed(3)
                                    .replace(/[.,]00$/, "")} $MLD`}
                                </TableCell>

                                {/* <TableCell>
                          {moment(mData.start).format("DD/MM/YYYY HH:mm:ss") ||
                            mData.start}
                        </TableCell>
                        <TableCell>
                          {moment(mData.maturity).format(
                            "DD/MM/YYYY HH:mm:ss"
                          ) || mData.maturity}
                        </TableCell> */}

                                {/* <Modal
                          aria-labelledby="modal-title"
                          aria-describedby="modal-desc"
                          open={confirmopen}
                          onClose={() => setConfirmopen(false)}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ margin: "0 10px" }}>
                            <Sheet
                              variant="outlined"
                              sx={{
                                maxWidth: 500,
                                borderRadius: "md",
                                p: 3,
                                boxShadow: "lg",
                              }}
                            >
                              <ModalClose
                                variant="outlined"
                                sx={{
                                  top: "calc(-1/4 * var(--IconButton-size))",
                                  right: "calc(-1/4 * var(--IconButton-size))",
                                  boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                                  borderRadius: "50%",
                                  bgcolor: "background.surface",
                                }}
                              />
                              <Typography
                                component="h2"
                                id="modal-title"
                                level="h4"
                                textColor="inherit"
                                fontWeight="lg"
                                mb={1}
                              >
                                Are you sure you want to withdraw prematurely?
                              </Typography>
                              <ConfirmButtonWrapperPopup>
                                <ConfirmButtonPopup
                                  onClick={() => setConfirmopen(false)}
                                >
                                  Cancel
                                </ConfirmButtonPopup>
                                <ConfirmButtonPopup
                                  onClick={async (e) => {
                                    setConfirmopen(false);
                                    e.preventDefault();
                                    setLoading(true);
                                    await withdraw(mData.index);
                                  }}
                                >
                                  Confirm
                                </ConfirmButtonPopup>
                              </ConfirmButtonWrapperPopup>
                            </Sheet>
                          </div>
                        </Modal> */}

                                <DialogStyledUpdate
                                  open={preMaturePopup}
                                  onClose={() => setPreMaturePopup(false)}
                                  aria-labelledby="alert-dialog-title"
                                  aria-describedby="alert-dialog-description"
                                  PaperProps={{
                                    sx: {
                                      overflow: "initial",
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                >
                                  <ButtonCancel
                                    onClick={() => setPreMaturePopup(false)}
                                    color="primary"
                                  >
                                    X
                                  </ButtonCancel>
                                  <div className={classes.customButton}>
                                    <DialogTitle
                                      id="alert-dialog-title"
                                      style={{
                                        textAlign: "left",
                                        fontSize: "28px",
                                        fontWeight: "500",
                                        padding: "0",
                                      }}
                                    >
                                      Bailing out too soon?
                                    </DialogTitle>
                                    <DialogContent
                                      style={{ padding: "0 0 40px" }}
                                    >
                                      <DialogContentText
                                        id="alert-dialog-description"
                                        style={{
                                          textAlign: "left",
                                          color: "#bbb",
                                          fontSize: "16px",
                                        }}
                                      >
                                        Verify your details to confirm early
                                        exit
                                      </DialogContentText>
                                    </DialogContent>

                                    <NftNameConfirm>
                                      <NftNameConfirmHead>
                                        $MLD Stake :
                                      </NftNameConfirmHead>
                                      <NftNameConfirmHead>
                                        {" "}
                                        {`${parseFloat(mData.mldStaked).toFixed(
                                          2
                                        )} $MLD`}
                                      </NftNameConfirmHead>
                                    </NftNameConfirm>

                                    <NftAmountConfirmHeadPur>
                                      <NftAmountConfirmHead2>
                                        Lord Burn :
                                      </NftAmountConfirmHead2>
                                      <NftAmountConfirmSubHead3>
                                        100% Lord
                                      </NftAmountConfirmSubHead3>
                                    </NftAmountConfirmHeadPur>
                                    <NftAmountConfirmHeadPur>
                                      <NftAmountConfirmHead2>
                                        Premature Penalty (5%) :
                                      </NftAmountConfirmHead2>
                                      <NftAmountConfirmSubHead3>
                                        {`${
                                          parseFloat(mData.mldStaked).toFixed(
                                            2
                                          ) * 0.05
                                        } $MLD`}
                                      </NftAmountConfirmSubHead3>
                                    </NftAmountConfirmHeadPur>
                                    <NftAmountConfirmHeadPur>
                                      <NftAmountConfirmHead2>
                                        Total Amount :
                                      </NftAmountConfirmHead2>
                                      <NftAmountConfirmSubHead3>
                                        {/* {`${(parseFloat(mData.mldStaked).toFixed(2))-{`${(parseFloat(mData.mldStaked).toFixed(2))*0.05 }`} } MLD`} */}
                                        {parseFloat(mData.mldStaked).toFixed(
                                          2
                                        ) -
                                          parseFloat(mData.mldStaked).toFixed(
                                            2
                                          ) *
                                            0.05}{" "}
                                        $MLD
                                      </NftAmountConfirmSubHead3>
                                    </NftAmountConfirmHeadPur>

                                    <NftAmountConfirmHeadPur>
                                      <NftAmountConfirmHead2>
                                        Transaction Fee :
                                      </NftAmountConfirmHead2>
                                      <NftAmountConfirmSubHead3>
                                        {gasFee
                                          ? `${gasFee.toFixed(4)} Matic`
                                          : "0.026 Matic"}
                                      </NftAmountConfirmSubHead3>
                                    </NftAmountConfirmHeadPur>

                                    <DialogActions>
                                      <PayButtons>
                                        <ButtonConfirm
                                          onClick={async (e) => {
                                            setPreMaturePopup(false);
                                            setConfirmopen(false);
                                            e.preventDefault();
                                            setLoading(true);
                                            await withdraw(mData.index);
                                          }}
                                          color="primary"
                                          autoFocus
                                        >
                                          Confirm
                                        </ButtonConfirm>
                                      </PayButtons>
                                    </DialogActions>
                                  </div>
                                </DialogStyledUpdate>

                                <TableCell>
                                  <PrematureButtonWrapper>
                                    <PrematureButton
                                      // onClick={async (e) => {
                                      //   e.preventDefault();
                                      //   setLoading(true);
                                      //   await withdraw(mData.index);
                                      // }}
                                      onClick={() =>
                                        handlePremature(mData.index)
                                      }
                                    >
                                      {new Date() >= new Date(mData.maturity)
                                        ? "Unstake"
                                        : "Premature Withdraw"}
                                    </PrematureButton>
                                  </PrematureButtonWrapper>
                                </TableCell>
                              </TableRowCellWrapper>
                            </>
                          );
                        })}
                  </Table>
                </TableWrapper>
              </TableCard>
            </>
          )}
        </>
      ) : (
        <>
          <TextNoData>Login to view Staked $MLD</TextNoData>
          <div
            style={{
              background: "#172930",
              borderRadius: "50px",
              fontSize: "15px",
              cursor: "pointer",
              fontWeight: "600",
              border: "1px solid #153339",
              padding: "12px 30px",
              color: "#267383",
              width: "140px",
              margin: "0 auto",
              textAlign: "center",
              marginBottom: "30px",
            }}
            onClick={handleLogin}
          >
            Login
          </div>
        </>
      )}
      <>
        {/* <table>
        Mature Data
        <tr>
          <th>durationStaked</th>
          <th>lordStaked</th>
          <th>start</th>
          <th>maturity</th>
          <th>maturityAmount</th>
          <th>mldStaked</th>
          <th>action</th>
        </tr>
        {matureData?.length > 0 &&
          matureData
            .sort((a, b) => a.maturity - b.maturity)
            .map((mData) => {
              return (
                <>
                  <tr>
                    <td>{ms(mData.durationStaked * 1000)} Month</td>
                    <td>{parseFloat(mData.lordStaked).toFixed(2)}</td>
                    <td>
                      {moment(mData.start).format("DD/MM/YYYY HH:mm:ss") ||
                        mData.start}
                    </td>
                    <td>
                      {moment(mData.maturity).format("DD/MM/YYYY HH:mm:ss") ||
                        mData.maturity}
                    </td>
                    <td>{parseFloat(mData.maturityAmount).toFixed(3)}</td>
                    <td>{parseFloat(mData.mldStaked).toFixed(2)}</td>
                    <td>
                      <button
                        onClick={async (e) => {
                          e.preventDefault();
                          setLoading(true);
                          await withdraw(mData.index);
                        }}
                      >
                        {new Date() >= new Date(mData.maturity)
                          ? "unstake"
                          : "premature withdraw"}
                      </button>
                    </td>
                  </tr>
                </>
              );
            })}
      </table> */}
      </>

      {/* {showDepositPopup && (
        <ConnectWalletPopup
          showPopup={showDepositPopup}
          setShowPopup={setShowDepositPopup}
          onClickFun={depositPopup}
          text={"Congratulation you deposited successfully."}
        ></ConnectWalletPopup>
      )} */}

      {showDepositPopup && (
        <OverLay>
          <RootPopup
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <SuccessMain>
              <ButtonCancel
                onClick={() => {
                  setShowDepositPopup(false);
                  fetchingData();
                }}
              >
                x
              </ButtonCancel>
              <SuccessIconI src={SuccessIcon} />
              <Heading>$MLD Locked</Heading>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#cd2222",
                    textTransform: "capitalize",
                  }}
                  onClick={explorerHandler}
                >
                  view on explorer{" "}
                  <span>
                    <i class="fa-solid fa-arrow-up-right-dots"></i>
                  </span>
                </div>
              </div>
              <NftNameConfirm>
                <div>
                  <NftNameConfirmHead>$MLD Staked</NftNameConfirmHead>
                </div>
                <NftNameConfirmHead>{depositValue}</NftNameConfirmHead>
              </NftNameConfirm>
              <NftNameConfirm3>
                <NftNameConfirmSubHead>
                  Transaction Hash :
                </NftNameConfirmSubHead>
                <DetailsHead>
                  {depositeTransHash
                    ? `${depositeTransHash?.slice(0, 10)}......
                  ${depositeTransHash?.slice(-10)}`
                    : ``}
                  <CopyIcon onClick={() => CopyAddress(depositeTransHash)}>
                    <i class="fa-solid fa-copy"></i>
                    {isCopied && <ToolTipSpan>Copied</ToolTipSpan>}
                  </CopyIcon>
                </DetailsHead>
              </NftNameConfirm3>
              <NftNameConfirm3>
                <NftNameConfirmSubHead>Transaction Fee :</NftNameConfirmSubHead>
                <DetailsHead>{`${transactionFeeStake} Matic`}</DetailsHead>
              </NftNameConfirm3>
            </SuccessMain>
          </RootPopup>
        </OverLay>
      )}

      {showWithdrawPopup && (
        <OverLay>
          <RootPopup
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <SuccessMain>
              <ButtonCancel
                onClick={() => {
                  setPreMatureConfirmPopup(false);
                  setShowWithdrawPopup(false);
                  fetchingData();
                }}
              >
                x
              </ButtonCancel>
              <SuccessIconI src={SuccessIcon} />
              <Heading>$MLD Unstaked</Heading>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#cd2222",
                    textTransform: "capitalize",
                  }}
                  onClick={explorerHandler}
                >
                  view on explorer{" "}
                  <span>
                    <i class="fa-solid fa-arrow-up-right-dots"></i>
                  </span>
                </div>
              </div>
              <NftNameConfirm>
                <div>
                  <NftNameConfirmHead>$MLD Unstaked</NftNameConfirmHead>
                </div>
                <NftNameConfirmHead>{depositValue}</NftNameConfirmHead>
              </NftNameConfirm>
              <NftNameConfirm3>
                <NftNameConfirmSubHead>
                  Transaction Hash :
                </NftNameConfirmSubHead>
                <DetailsHead>
                  {`${transactionHashStake?.slice(
                    0,
                    10
                  )}...${transactionHashStake?.slice(-10)}`}
                  <CopyIcon onClick={() => CopyAddress(transactionHashStake)}>
                    <i class="fa-solid fa-copy"></i>
                    {isCopied && <ToolTipSpan>Copied</ToolTipSpan>}
                  </CopyIcon>
                </DetailsHead>
              </NftNameConfirm3>
              <NftNameConfirm3>
                <NftNameConfirmSubHead>Transaction Fee :</NftNameConfirmSubHead>
                <DetailsHead>{`${transactionFeeStake} Matic`}</DetailsHead>
              </NftNameConfirm3>
            </SuccessMain>
          </RootPopup>
        </OverLay>

        // <ConnectWalletPopup
        //   showPopup={showWithdrawPopup}
        //   setShowPopup={setShowWithdrawPopup}
        //   onClickFun={withdrawPopup}
        //   text={"Congratulation you withdraw successfully."}
        // ></ConnectWalletPopup>
      )}
    </>
  );
};

export default InfoSection;
